module.exports = __webpack_public_path__ + "img/teacher-pic001.7bf8357f.jpg";